// extracted by mini-css-extract-plugin
module.exports = {"mCard":"ai-z","image":"bi-z","imageNoBackground":"ci-z"};